// Vuex transaction module actions
import { API } from '@/config';
import { FILL_DETAILS, EXPORT_FILE } from './mutations-types';

export default {

  async getDetails({ commit }, report) {
    try {
      const params = { report };
      const { record, total } = (await API.get('/report/getDetails', { params })).data.data;
      commit(FILL_DETAILS, { record, total });
    } catch (err) {
      console.log(err);
    }
  },

  async exportReport({ commit, state }, params) {
    const paramsCopy = {
      report: state.details.record.uuid,
      fields: params,
    };
    let response = null;
    try {
      response = (await API.post('/report/exportReport', { ...paramsCopy })).data.data;
      if (response !== 'no_content') {
        commit(EXPORT_FILE, response);
      }
      return response;
    } catch (err) {
      console.log(err);
    }
    return response;
  },
};
